export interface Prices {
  METAL: number
  TRANSPONDER: number
  PROXIMITY: number
}

export interface Company {
  id: string
  name: string
  prices: Prices
}

export interface Location {
  id: string
  name: string
  company: Company
  phoneNumber: string  
}

export const defaultCompany:Company = {
  id: '',
  name: '',
  prices: {
    METAL: 0,
    TRANSPONDER: 0,
    PROXIMITY: 0
  }
}

export const defaultLocation: Location = {
  id: '', 
  name: '',
  company: defaultCompany, 
  phoneNumber: ''
}